import React, { useState } from "react";
import { zoneImages } from "../../../../lib/constants/globalConstant"; // Adjust the path as necessary
import { tokenSelectorStyles as styles } from "../../deployToken.tailwind";
import Cube from "../../../shared/Others/Cube/Cube";
import { Skeleton } from '@mui/material';

const TokenDataContainer = React.forwardRef(({ tokenNumber, zoneCategory, actionImage, playerImage, isSelected, onClick, isCurrentDeployed, zoneNumber, canvasRef,deployedImage }, ref) => {
  console.log(zoneCategory)
  const tokenImage = zoneImages[zoneCategory] || null; // token-image
  const [isLoadingImage, setIsLoadingImage] = useState(true);

  const handleImageLoad = () => {
    setIsLoadingImage(false);
  };
  return (
    <div className={`${styles.tokenDataContainer} ${isSelected ? styles.selectedtokenDataContainer : ''}`}  onClick={onClick} ref={ref}>
      <div className={styles.tokenNumber}>#{tokenNumber}</div> {/* token-number */}
      <div className="absolute rounded-[25px] shadow-[0_0_0_0.12px_#fff] text-center text-[10px] leading-[14px] font-[500] whitespace-nowrap px-1 top-1 right-1">{zoneNumber}</div> {/* zone-category */}

      <div className={styles.imageContainer}>
        {/* 3D token-cube */}
        {/* {isCurrentDeployed && (actionImage && playerImage && actionImage?.src && playerImage?.src)
          ? <Cube actionImage={actionImage?.src} playerImage={playerImage?.src} canvasRef={canvasRef} />
          : (
              <>
                <img src={tokenImage} alt="token_image" className={styles.tokenImage} />
                <div className="hidden">
                  <Cube actionImage={actionImage?.src} playerImage={playerImage?.src} canvasRef={canvasRef} />
                </div>
              </>
            )
        } */}

        {(isCurrentDeployed && (actionImage && playerImage && actionImage?.src && playerImage?.src)) ? (
            // Show the deployed image if it's deployed
            deployedImage ? (
              <>
                {isLoadingImage && <Skeleton animation="wave" variant="rectangular"  width="100%" 
                  height="80%"  sx={{ position: "absolute", top: 20, left: 0,  backgroundColor: "var(--themeShadowColor)" }}   />}
                <img 
                  src={deployedImage} 
                  alt="token_image" 
                  className={styles.deployedtokenImage} 
                  onLoad={handleImageLoad}
                  style={{ display: !isLoadingImage ? 'block' : 'none' }}
                />
              </>
            ) : <Cube actionImage={actionImage?.src} playerImage={playerImage?.src} canvasRef={canvasRef} />
          ) : (
            // If not deployed, handle actionImage and playerImage or default token image
            (actionImage?.src && playerImage?.src) ? (
              <Cube actionImage={actionImage.src} playerImage={playerImage.src} canvasRef={canvasRef} />
            ) : (
              <img src={tokenImage} alt="token_image" className={styles.tokenImage} />
            )
          )}

        {/* actions and player-image */}
        {!isCurrentDeployed && (
          <div className={styles.selectionContainer}>
            {/* action-image */}
            {actionImage && (
              <div className={styles.actionImageWrapper}>
                <img src={actionImage?.src} alt={actionImage?.alt} className={styles.actionImage} /> {/* action-image */}
                <div className={styles.imageText}>{actionImage?.text}</div>                          {/* image-text (player name/ action name) */}

                {/* overlay */}
                <div
                  className="absolute top-0 left-0 w-full h-full"
                  style={{
                    background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 69.84%, rgba(0, 0, 0, 0.55) 87%, rgba(0, 0, 0, 0.80) 99.61%)`,
                  }}
                />
              </div>
            )}

            {/* player-image */}
            {playerImage && (
              <div className={styles.actionImageWrapper}>
                <img src={playerImage?.src} alt="player_image" className={styles.actionImage} /> {/* player-image */}
                <div className={styles.imageText}>{playerImage?.text}</div>                      {/* image-text (player name/ action name) */}

                {/* overlay */}
                <div
                  className="absolute top-0 left-0 w-full h-full"
                  style={{
                    background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 69.84%, rgba(0, 0, 0, 0.55) 87%, rgba(0, 0, 0, 0.80) 99.61%)`,
                  }}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

TokenDataContainer.displayName = TokenDataContainer;

export default TokenDataContainer;
